import axios from 'axios';
import { API_URL } from '../../../utils/constants';
import { toast } from "react-toastify";

export const getAzureSubApi = async (param, provider) => {
  const token = localStorage.getItem('api_token');
  try {
    param.params.type = 2;
    const endpoint = provider === "gcp" ? "gcp/projects" : "subscriptions";
    const response = await axios({
      method: 'GET',
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },
      data: param.params
    });
    return response
  } catch (e) {
    return [];
  }
};
